import React, { useState } from 'react';
import classnames from 'classnames/bind';
import { Button } from 'antd';
import { apis, apiHolder as api } from 'api';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import DiscussIntro from '@web-common/components/UI/DiscussIntro/discussIntro';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import style from './chatForward.module.scss';
import { MailActions } from '@web-common/state/reducer';
import { useActions } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const realStyle = classnames.bind(style);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
export const ChatForwardFooter = props => {
    const { onVisibleChange, sendForwardMsg, okText = getIn18Text('ZHUANFA'), loading = false, checkedSessionIds, mailMid = '' } = props;
    const [shareIntro, setShareIntro] = useState(false);
    const mailActions = useActions(MailActions);
    const handleDiscussTrack = (type) => {
        trackApi.track(type);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: realStyle('footerWrapper') },
            okText === getIn18Text('FENXIANG') ? (React.createElement("p", { className: realStyle('discuss') },
                getIn18Text('WUHESHIHUIHUA'),
                React.createElement("span", { className: realStyle('discussLaunch'), onClick: () => {
                        mailActions.doUpdateShareMailMid(mailMid);
                        handleDiscussTrack('pcMail_click_shareMailPage_addNewEmailChat');
                    } }, getIn18Text('QUFAQIXINDE')),
                React.createElement(QuestionCircleOutlined, { className: realStyle('discussIcon'), onClick: () => {
                        handleDiscussTrack('pcMail_click_shareMailPage_mailChatIntroduce');
                        setShareIntro(true);
                    } }))) : null,
            React.createElement("section", { className: realStyle('btns') },
                React.createElement("span", { className: realStyle('createSessionBtn', 'btn') }, getIn18Text('CHUANGJIANXINHUIHUA'))),
            React.createElement("section", { className: realStyle('btns') },
                React.createElement(Button, { className: realStyle('cancelBtn'), onClick: () => onVisibleChange(false) }, getIn18Text('QUXIAO')),
                React.createElement(Button, { loading: loading, type: "primary", className: realStyle('forwardBtn'), onClick: () => sendForwardMsg(), disabled: !checkedSessionIds.length }, okText))),
        React.createElement(Modal, { modalRender: () => React.createElement(DiscussIntro, { mailMid: mailMid, close: () => setShareIntro(false) }), wrapClassName: "discuss-intro-wrap", centered: true, visible: shareIntro, maskStyle: { left: '68px', zIndex: 1090 } })));
};
